var MemberList = require('memberlist');


var MemberVoicedList = MemberList.extend({
    modeCategory: 'VOICED'
});


module.exports = MemberVoicedList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/membervoicedlist.js
// module id = XDey
// module chunks = 1